import gql from 'graphql-tag';

export const TERMO_TIPO = gql`
  query($tipo: TipoTermoUsoEnum!) {
    obterTermoVigentePorTipo(tipo: $tipo) {
      id
      texto
      vigente
    }
  }
`;
